import { Injectable } from "@angular/core";
import { PowerSupplyVendor, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyVendorService {
  constructor(private powerSupplyService: DefaultService) {
    this.getPowerSupplyVendors();
  }

  public getPowerSupplyVendors() {
    return this.powerSupplyService.getPowerSupplyVendors()
      .pipe(map(result => result));
  }

  public createPowerSupplyVendor(model: PowerSupplyVendor) {
    return this.powerSupplyService.createPowerSupplyVendor(model)
      .pipe(map(result => result));
  }

  public updatePowerSupplyVendor(model: PowerSupplyVendor) {
    return this.powerSupplyService.updatePowerSupplyVendor(model)
      .pipe(map(result => result));
  }

  public deletePowerSupplyVendor(id: number) {
    return this.powerSupplyService.deletePowerSupplyVendor(id)
      .pipe(map(result => result));
  }

  public getPowerSupplyVendorsByRootId(rootId: number) {
    return this.powerSupplyService.getPowerSupplyVendorsByRootId(rootId)
      .pipe(map(result => result));
  }
}
